import { BaseModal } from './BaseModal';

interface Props {
  content?: JSX.Element | string,
  header?: string,
  trigger?: any,
  children?: JSX.Element,
}

export const ContentModal = ({ content = '', header = 'Privacy Policy', trigger = 'Learn More', children }: Props) => 
  <BaseModal 
    trigger={trigger}
    header={header}
  >
    {content || children}
  </BaseModal>